import React from 'react';
import { useTranslation } from 'react-i18next';
import { murmurhash } from '../../../../../lib/js/hash';
import { Table, TableBody, TableCell, TableHead, TableModifier, TableRow } from '../../../../organisms/Table';
import { Namespace } from '../../../../../translation/namespace';
import { SearchResultTeaser } from '../../../../molecules/SearchResultTeaser/SearchResultTeaser';
import { DateFormat } from '../../../../../_lib/components/DateFormat';
import { Strong } from '../../../../atoms/Strong/Strong';
import { ResultContent } from '../../../../../_blocks/Search/Search.types';

type ContentSearchResultTableProps = {
  items: ResultContent[];
};

export default function ContentSearchResultTable({ items }: ContentSearchResultTableProps) {
  const { t } = useTranslation(Namespace.ContentSearchResults);
  const hasConfidentialLevel = items.some(item => item.confidentialLevel !== undefined);

  return (
    <Table caption={t('caption')} removeOnPaste>
      <TableHead>
        <TableRow>
          <TableCell>{t('label.content')}</TableCell>
          {hasConfidentialLevel && <TableCell>{t('label.confidentialLevel')}</TableCell>}
          <TableCell modifier={TableModifier.SWIDTH}>{t('label.date')}</TableCell>
        </TableRow>
      </TableHead>
      <TableBody>
        {items.map(item => (
          <TableRow key={`result-item-${murmurhash(item)}`}>
            <TableCell dataHead={t('label.content')}>
              <SearchResultTeaser {...item} />
            </TableCell>
            {hasConfidentialLevel && (
              <TableCell>
                <Strong>
                  <span>{item.confidentialLevel}</span>
                </Strong>
              </TableCell>
            )}
            <TableCell dataHead={t('label.date')}>
              <DateFormat date={item.contentDate} />
            </TableCell>
          </TableRow>
        ))}
      </TableBody>
    </Table>
  );
}
